import angularModule from 'Careers/angularModule/scripts/careers_module';
import defaultImageUrl from 'vectors/graduationcap.svg';
import { DEGREE_OPTIONS_MAP, LEVEL_ORDER } from '../../../degreeOptions';

angularModule.factory('EducationExperience', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');
        const TranslationHelper = $injector.get('TranslationHelper');
        const educationExperienceDetailTranslationHelper = new TranslationHelper(
            'careers.edit_career_profile.education_experience_detail',
        );

        return Iguana.subclass(function () {
            this.alias('EducationExperience');
            this.setIdProperty('id');
            this.embedsMany('transcripts', 'S3TranscriptAsset');

            this.extend({
                levelOrder: LEVEL_ORDER,
                degreeOptions: Object.keys(DEGREE_OPTIONS_MAP),

                levelForDegreeKey(key) {
                    return DEGREE_OPTIONS_MAP[key] || null;
                },
            });
            this.degreeOptionsSet = {};
            this.degreeOptions.forEach(key => {
                this.degreeOptionsSet[key] = true;
            });

            this.setCallback('after', 'copyAttrsOnInitialize', function () {
                this.transcripts = this.transcripts || [];
            });

            Object.defineProperty(this.prototype, 'imageUrl', {
                get() {
                    return this.educational_organization && this.educational_organization.image_url
                        ? this.educational_organization.image_url
                        : defaultImageUrl;
                },
            });

            Object.defineProperty(this.prototype, 'orgName', {
                get() {
                    return this.educational_organization && this.educational_organization.text;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeAndMajorString', {
                get() {
                    return [this.degreeName, this.major].filter(Boolean).join(', ');
                },
            });

            Object.defineProperty(this.prototype, 'degreeAndOrgNameString', {
                get() {
                    // Degree is required in the application form, but I do see some in the db
                    // without it, so being defensive here
                    return this.degreeName ? `${this.degreeName} - ${this.orgName}` : this.orgName;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeName', {
                get() {
                    return this.constructor.degreeOptionsSet[this.degree]
                        ? educationExperienceDetailTranslationHelper.get(this.degree)
                        : this.degree;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'degreeProgram', {
                get() {
                    return this.degree_program;
                },
                set(val) {
                    this.degree_program = val;
                },
            });

            Object.defineProperty(this.prototype, 'willNotComplete', {
                get() {
                    return this.will_not_complete;
                },
                set(val) {
                    this.will_not_complete = val;
                },
            });

            // this determines if the education experience is empty in the context of the education form.
            // if any of the form fields change, we should verify that this property still works as expected
            Object.defineProperty(this.prototype, 'isEmpty', {
                get() {
                    return (
                        (!this.educational_organization || !this.educational_organization.text) &&
                        !this.degree &&
                        !this.major &&
                        !this.minor &&
                        !this.gpa &&
                        angular.isUndefined(this.willNotComplete)
                    );
                },
            });

            Object.defineProperty(this.prototype, 'transcriptUploaded', {
                get() {
                    return this.transcripts.length > 0;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptUploaded', {
                get() {
                    return this.transcripts.filter(transcript => transcript.transcript_type === 'official').length > 0;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'unofficialTranscripts', {
                get() {
                    return this.transcripts.filter(transcript => transcript.transcript_type === 'unofficial');
                },
                configurable: true,
            });

            // See also transcript_requirement_helper.rb
            Object.defineProperty(this.prototype, 'canRequireOfficial', {
                get() {
                    return (
                        this.degreeProgram &&
                        !this.will_not_complete &&
                        this.graduation_year <= new Date().getFullYear()
                    );
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptUploadedOrWaived', {
                get() {
                    return this.officialTranscriptUploaded || this.transcriptWaived;
                },
                configurable: true,
            });

            // See also education_experience.rb
            Object.defineProperty(this.prototype, 'transcriptApprovedOrWaived', {
                get() {
                    return this.transcript_approved || this.transcriptWaived;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'officialTranscriptInReview', {
                get() {
                    return this.official_transcripts_in_review;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'transcriptWaived', {
                get() {
                    return !!this.transcript_waiver;
                },
                configurable: true,
            });

            return {};
        });
    },
]);
